import { IDocumentType } from "store/lobby/lobby-model";
import { IProcessData } from "store/location/location-model";
import { searchVehicleStepsIdentifierById } from "utils/functions";

export interface ICreateUnitForm {
  id?: number;
  description: string;
  code: string;
  country: string;
  companyDocument: string;
  city: string;
  addressState: string;
  region: string;
  structureId: string;
}

export interface IProcessActive {
  id: number;
  vehicleSteps: number[];
  active?: boolean;
  description?: string;
}

export interface ICreateUnit {
  form: any;
  message: string | any;
  messageDescription: string;
  structureRequiredMessage: string;
  checked: boolean;
  locationSaveAsync: (...args) => void;
  checkedProcess: IProcessData[];
  checkedStructureId: number;
  hasAttendanceActive: boolean;
  expirationTimeActive: number;
  checkinActive: boolean;
  allowRequestDockEntryAction: boolean;
  allowRequestVehicleInboundAction: boolean;
  hasFinishOperationAction: boolean;
  allowRequestVehicleEntryAuthorizationAction: boolean;
  allowVehicleArrivalConfirmAction: boolean;
  hasReleaseWMSDocuments: boolean;
  hasLocationOutOfRange: boolean;
  hasCheckinSchedule: boolean;
  hasEntryPermission: boolean;
  hasRfidReading: boolean;
  documentTypeActive: IDocumentType;
  dropHookTypeActive: number;
  plateFormatType: number;
}

export const onConfirmCreateUnit = async ({
  form,
  message,
  messageDescription,
  checked,
  locationSaveAsync,
  checkedProcess,
  checkedStructureId,
  expirationTimeActive,
  checkinActive,
  allowRequestDockEntryAction,
  allowRequestVehicleInboundAction,
  hasFinishOperationAction,
  allowRequestVehicleEntryAuthorizationAction,
  hasAttendanceActive,
  allowVehicleArrivalConfirmAction,
  hasReleaseWMSDocuments,
  hasLocationOutOfRange,
  hasCheckinSchedule,
  documentTypeActive,
  structureRequiredMessage,
  dropHookTypeActive,
  hasEntryPermission,
  hasRfidReading,
  plateFormatType,
}: ICreateUnit) => {
  try {
    const basicFields = ["description", "code", "country", "companyDocument", "city", "addressState", "structureId", "region"];
    const { description, code, country, companyDocument, city, addressState }: Partial<ICreateUnitForm> = await form.validateFields(basicFields);
    const id = form.getFieldValue("id");
    const structureIdActive = checkedStructureId;
    if (!structureIdActive) {
      message.error(structureRequiredMessage);
      return;
    }

    const processesActive = checkedProcess
      .filter((x) => x.active === true)
      .map((x) => ({
        id: x.id,
        vehicleStepIds: searchVehicleStepsIdentifierById(x.vehicleSteps),
      }));

    const bodyRequest = {
      description,
      code: code.trim().length === 0 ? "" : code,
      country,
      companyDocument,
      city,
      addressState,
      active: checked,
      processes: processesActive,
      structureId: structureIdActive,
      hasCheckin: checkinActive,
      hasAttendance: hasAttendanceActive,
      checkinExpirationTime: expirationTimeActive === null ? 0 : expirationTimeActive,
      allowRequestVehicleInboundAction,
      allowRequestDockEntryAction,
      hasFinishOperationAction,
      allowRequestVehicleEntryAuthorizationAction,
      allowVehicleArrivalConfirmAction,
      hasReleaseWMSDocuments,
      hasLocationOutOfRange,
      hasCheckinSchedule,
      documentType: documentTypeActive,
      dropHookTypeOfYard: dropHookTypeActive ?? 0,
      hasEntryPermission,
      hasRfidReading,
      plateFormatType,
    };
    locationSaveAsync(bodyRequest, id);
  } catch (e) {
    console.error(new Error("Create unit form validation error"));
    message.error(messageDescription);
  }
};
